export default __webpack_public_path__ + "static/media/Empty-Cart.a52e259a.jpg";